import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Execute from 'components/inspection/modal/execute';
import InspectionStatus from 'utils/inspection_state';

const ExecuteButton = ({ inspection, space, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      disabled={inspection.status !== InspectionStatus().PENDING || !space.inspectorRole}
      color="success"
      variant="contained"
      onClick={() => {
        addModal(
          <Execute
            inspection={inspection}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.inspection.executed');
            }}
            handleClose={() => removeModal()}
          />
        );
      }}
    >
      <FormattedMessage id="button.execute" />
    </Button>
  );
};

export default ExecuteButton;
